import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../Hook/AuthProvider";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import AdminAccessDenied from "./AdminAccessDenied";
import { ROUTES } from "../../constants/routes";

export default function AdminProtectedRoute({ children, requiredPermission }) {
  const { isAuthenticated, isInitialized } = useContext(AuthContext);
  const { can } = useAdminAuth();

  if (!isInitialized) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  if (requiredPermission && !can(requiredPermission)) {
    return <AdminAccessDenied requiredPermission={requiredPermission} />;
  }

  return children;
}
